import {Injectable} from "@angular/core";
import { ConnectionBackend, RequestOptions, Request, RequestOptionsArgs, Response, Http, Headers, URLSearchParams} from "@angular/http";
import {Observable} from "rxjs/Rx";
import {environment} from "../../environments/environment";


@Injectable()
export class InterceptedHttp extends Http {

    constructor(backend: ConnectionBackend, defaultOptions: RequestOptions) {
        super(backend, defaultOptions);
    }

    request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
        return super.request(url, options);
    }

    get(url: string, options?: RequestOptionsArgs): Observable<Response> {
        //url = this.updateUrl(url);
        return super.get(url, this.getRequestOptionArgs(options));
    }

    post(url: string, body: string, options?: RequestOptionsArgs): Observable<Response> {
        //url = this.updateUrl(url);
        return super.post(url, body, this.getRequestOptionArgs(options));
    }

    patch(url: string, body: string, options?: RequestOptionsArgs): Observable<Response> {
        //url = this.updateUrl(url);
        return super.patch(url, body, this.getRequestOptionArgs(options));
    }

    put(url: string, body: string, options?: RequestOptionsArgs): Observable<Response> {
        //url = this.updateUrl(url);
        return super.put(url, body, this.getRequestOptionArgs(options));
    }

    delete(url: string, options?: RequestOptionsArgs): Observable<Response> {
        //url = this.updateUrl(url);
        return super.delete(url, this.getRequestOptionArgs(options));
    }

    private updateUrl(req: string) {
        return  environment.BASE_URL_BACKEND + req;
    }

    private getRequestOptionArgs(options?: RequestOptionsArgs) : RequestOptionsArgs {
        if (options == null) {
            options = new RequestOptions();
        }
        if (options.headers == null) {
            options.headers = new Headers();
        }

        let opcoHeader = localStorage.getItem('opco-header');
        //let csrf = this.readCookie("X-CSRF-TOKEN");        

        if(opcoHeader || opcoHeader!=="" || opcoHeader!==undefined){
          options.headers.append('x-vf-trace-nv-opco-id', opcoHeader);
        } 

        // if (csrf || csrf !== "" || csrf !== undefined) {
        //     options.headers.append('X-CSRF-TOKEN', csrf);
        // }      

        return options;
    }

    private readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }
}


// WEBPACK FOOTER //
// ./src/app/_services/http.service.ts